export enum RiskItemInformations {
  NATURE_OCCU = "NATURE_OCCU",
  ADR_RISQUE = "ADR_RISQUE",
  ADR_CODE_POSTAL = "ADR_CODE_POSTAL",
  POSSEDE_ENERGIEV = "POSSEDE_ENERGIEV",
  NBR_PIECES = "NBR_PIECES",
  NBR_PIECES_40M2 = "NBR_PIECES_40M2",
  POSSEDE_PISCINE = "POSSEDE_PISCINE",
  NATURE_LOG = "NATURE_LOG",
  NBR_PERS = "NBR_PERS",
  OBJ_VAL_GLOB = "OBJ_VAL_GLOB",
  HAB_TYPE = "HAB_TYPE",
  CAP_MOB = "CAP_MOB",
  OBJ_VAL_UNIT = "OBJ_VAL_UNIT",
  ADR_COMP = "ADR_COMP",
  POSSEDE_VERANDA = "POSSEDE_VERANDA",
  ADR_VILLE = "ADR_VILLE",
  SURFACE_DEP = "SURFACE_DEP",
  CAP_MOB_BESOIN = "CAP_MOB_BESOIN",
  ADR_ETAGE = "ADR_ETAGE",
  NOM_BAILLEUR = "NOM_BAILLEUR",
  ANIMAL_ID = "ID_ANI",
}
